import {msgSendAI} from "../../helper/utils";
import DisplayMessage from "../components/DisplayMessage/DisplayMessage";


export const DUMMY_MESSAGE_ID = "__LOADING__";

class ActionProvider {
	
	constructor(createChatBotMessage, setStateFunc) {
    	this.createChatBotMessage = createChatBotMessage;
    	this.setState = setStateFunc;
  	}

  	addMessageToState = (message, removeLoading = false) => {
    	this.setState((prevState) => {
      	const newMessages = removeLoading
        	? prevState.messages.filter((msg) => msg.message !== DUMMY_MESSAGE_ID)
        	: [...prevState.messages];

      		return {
        		...prevState,
        		messages: [...newMessages, message],
      		};
    	});
  	};

  	greet = (botMessage, removeLoading = false) => {
    	const message = this.createChatBotMessage(botMessage);
    	this.addMessageToState(message, removeLoading);
  	};

  	clientMessage = async (clientMessage) => {
    	this.greet(DUMMY_MESSAGE_ID); 

    	try {
      		const result = await msgSendAI(clientMessage);
      
      		this.greet(<DisplayMessage json={result} originalQuestion={clientMessage}/>, true);
    	} catch (e) {
      		this.greet("Oops! Da ging was schief. 🤯", true);
    	}
  	};
}


export default ActionProvider;
